import React, { useState, useEffect, useMemo } from 'react';
import { generateGoogleWalletPass, getWalletPassUrl } from 'apis/googleWalletApi';
import { createAppleWalletPass } from 'apis/appleWalletApi';
import { getUniversalWalletPassUrl } from 'apis/universalWalletApi'; // Add this import
// Import the Google Wallet button image
import walletButtonImage from 'images/wallet-button.png';
import { getCardById } from 'apis/cardApi';
import { useParams } from 'react-router-dom';
import TeamQRCodeGenerator from './TeamQRCode';
import { Box, Typography, CircularProgress, Stack, Button } from '@mui/material';

// Device detection utility
const detectDeviceType = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const platform = window.navigator.platform.toLowerCase();

    const isIOS = userAgent.includes('iphone') ||
        userAgent.includes('ipad') ||
        userAgent.includes('ipod') ||
        (userAgent.includes('mac') && 'ontouchend' in document);

    const isAndroid = userAgent.includes('android');

    return {
        isIOS,
        isAndroid
    };
};

const TeamSmartWallet = () => {
    const [cardDetails, setCardDetails] = useState(null);
    const { cardId } = useParams();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    const [qrCodeUrl, setQRCodeUrl] = useState('');

    useEffect(() => {
        const fetchCardDetails = async () => {
            if (!cardId) return;

            try {
                setLoading(true);
                const response = await getCardById(cardId);

                if (response?.success && response?.card) {
                    setCardDetails(response);
                    setError('');
                } else {
                    throw new Error('Card details not available');
                }
            } catch (error) {
                console.error('Error fetching card details:', error);
                setError('Failed to fetch card details');
            } finally {
                setLoading(false);
            }
        };

        fetchCardDetails();
    }, [cardId]);

    const qrCodeOptions = useMemo(() => ({
        format: 'png',
        size: 300,
        color: '#000000',
        backgroundColor: '#FFFFFF',
        dotType: 'square',
        eyeShape: 'square',
        eyeColor: '#000000',
        logoMargin: 10,
        logoSize: 0.3,
        logoCrossOrigin: 'anonymous',
        hideBackgroundDots: false,
    }), []);







    const handleQRCodeGenerated = (qrCodeUrl) => {
        setQRCodeUrl(qrCodeUrl);
    };

    const isCardValid = Boolean(cardDetails?.card?.contact_info?.fullName);

    return (
        <div>
            {loading && <CircularProgress />}

            {error && (
                <Typography variant="body1" color="error" sx={{ mt: 2, mb: 2, textAlign: 'center' }}>
                    {error}
                </Typography>
            )}

            {isCardValid && (
                <Stack spacing={2}>
                    <Box textAlign="center">
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            Scan to add to wallet
                        </Typography>
                        <Box sx={{ p: 1 }}> {/* Added padding around QR code */}
                            <TeamQRCodeGenerator
                                url={getUniversalWalletPassUrl(cardId)}
                                options={qrCodeOptions}
                                onQRCodeGenerated={handleQRCodeGenerated}
                                setLoading={setLoading}
                                setError={setError}
                            />

                            {qrCodeUrl && (
                                <img
                                    src={qrCodeUrl}
                                    alt="Wallet Pass QR Code"
                                    style={{
                                        width: '100%', // Make image responsive
                                        height: 'auto',
                                        display: 'block', // Remove any extra space
                                        margin: '0 auto' // Center the image
                                    }}
                                />
                            )}
                        </Box>

                        {/* Add to Google Wallet button - for screenshot only */}
                        <Box sx={{ mt: 2 }}>
                            <a href="#" style={{ display: 'inline-block' }}>
                                <img
                                    src={walletButtonImage}
                                    alt="Add to Google Wallet"
                                    style={{
                                        height: '48px',
                                        width: 'auto'
                                    }}
                                />
                            </a>
                        </Box>
                    </Box>
                </Stack>
            )}
        </div>
    );

};

export default TeamSmartWallet;